import { Center, Spinner } from '@frontend/components';

const AnalyticsSplashPage = () => {
  return (
    <Center>
      <Spinner size="xl" />
    </Center>
  );
};

export default AnalyticsSplashPage;
